import { fullApiUrl } from '@rover/utilities/apiUrl';

const RELATIONSHIP_URL: string = fullApiUrl('relationships/as-requester');

function buildAsRequesterRelationshipUrl(opk: string): string {
  return `${RELATIONSHIP_URL}/${opk}/`;
}

export default buildAsRequesterRelationshipUrl;
